import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function AccessSignUpRequestsItem({ request, handleAccept, handleReject }) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="align-items-center">
          <Col md={4}>
            <h5>
              {request.first_name} {request.last_name}
            </h5>
            <p className="mb-1">{request.email}</p>
            <p className="mb-1">
              {t("type")}: {request.type}
            </p>
            <p className="mb-1">
              {t("status")}: {t(request.status)}
            </p>
            <p className="mb-1">
              {t("created_at")}:{" "}
              {new Date(request.created_at).toLocaleDateString()}
            </p>
          </Col>
          <Col md={4} className="text-start">
            <Row>{t("message")}:</Row>
            <Row
              style={{
                maxHeight: "170px",
                overflowY: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {request.message}
            </Row>
          </Col>
          <Col md={4} className="text-end">
            <Button
              variant="success"
              className="me-2"
              onClick={() => handleAccept(request._id)}
              disabled={request.status !== "pending"}
            >
              {t("accept")}
            </Button>
            <Button
              variant="danger"
              onClick={() => handleReject(request._id)}
              disabled={request.status !== "pending"}
            >
              {t("reject")}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default AccessSignUpRequestsItem;
